module.exports = __webpack_public_path__ + "img/checkup-gift2.50b11918.png";